import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

const ageValidation = Yup.mixed().test('is-valid-age', 'Age must be a number between 1 and 150', value => {
  if (typeof value === 'number') {
    return value >= 1 && value <= 150;
  }
  return true; // Allow strings
});

export const editPatientValidation = Yup.object().shape({
  name: createValidationRule("string"),
  age: ageValidation, // Assuming you have a custom validation function for age
  date_of_birth: Yup.date().typeError("Invalid date format").nullable().test('date_of_birth', 'DOB is required', function(value) {
    // Check if the value is a valid date or an empty string
    if (value === "" || (value instanceof Date && !isNaN(value))) {
      return true; // Validation passed
    } else {
      return false; // Validation failed
    }
  }),
  patientContactNumber: createValidationRule("phone"),
  gender: Yup.string().oneOf(["Male", "Female", "Other"], "Gender is required"),
});
